import { fetchTokenHandoffCode } from "@app/store/app/actions";
import { getLegacyAppUrl } from "@app/util/appUrl";
import loggingService from "@app/util/logging";

type RequestCodeFetcher = typeof fetchTokenHandoffCode;

export const navigateToLegacyApp = (
  requestCode: RequestCodeFetcher,
  baseOldAppUrl: string,
  token: string | undefined,
  url: string
) =>
  requestCode({
    callback: (code) => {
      window.location.href = getLegacyAppUrl(baseOldAppUrl, token, url, code);
    },
    failureCallback: () => {
      window.location.href = getLegacyAppUrl(baseOldAppUrl, token, url);
    },
  });

export const openLegacyAppInNewTab = (
  requestCode: RequestCodeFetcher,
  baseOldAppUrl: string,
  token: string | undefined,
  url: string
) => {
  // opened synchronously in the click so the popup blocker allows it
  const newTab = window.open("about:blank", "_blank");
  if (!newTab) {
    // blocked: bail before minting a code we can't use, and leave the current tab
    // alone — navigating it away is more disruptive than the no-op it used to be
    loggingService.warning("legacy app switch aborted: popup blocked");
    return;
  }
  // sever window.opener while still same-origin (about:blank); passing noopener to
  // window.open instead would null the handle we need to redirect the tab
  newTab.opener = null;
  const go = (target: string) => {
    newTab.location.href = target;
  };
  requestCode({
    callback: (code) => go(getLegacyAppUrl(baseOldAppUrl, token, url, code)),
    failureCallback: () => go(getLegacyAppUrl(baseOldAppUrl, token, url)),
  });
};
